import { useQuery } from '@tanstack/react-query';
import { api } from './client';
/** List all non-draft tournaments. */
export function useListPublicTournaments() {
    return useQuery({
        queryKey: ['public', 'tournaments'],
        queryFn: () => api.request('/api/public/tournaments'),
        staleTime: 30_000,
    });
}
/** Get a single tournament by slug with public entries (names anonymized server-side). */
export function useGetPublicTournament(slug) {
    return useQuery({
        queryKey: ['public', 'tournaments', slug],
        queryFn: () => api.request(`/api/public/tournaments/${slug}`),
        enabled: slug.length > 0,
        staleTime: 30_000,
    });
}
/** Standings are embedded in the tournament detail. */
export function useGetPublicTournamentStandings(slug) {
    return useQuery({
        queryKey: ['public', 'tournaments', slug],
        queryFn: () => api.request(`/api/public/tournaments/${slug}`),
        enabled: slug.length > 0,
        staleTime: 30_000,
        select: (data) => data.entries,
    });
}
